import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Facebook, Instagram, Twitter } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-foreground text-background">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img src="/icon.png" alt="Bihari Mall Icon" className="w-9 h-9 object-contain" />
              <img src="/nav-logo.png" alt="Bihari Mall" className="h-8 w-auto object-contain brightness-0 invert" />
            </div>
            <p className="text-background/60 text-sm leading-relaxed mb-4">
              Bihari Mall is Bihar's trusted hyperlocal marketplace connecting you with the best neighborhood stores. 
              Shop fresh products with fast delivery and great savings.
            </p>
            <div className="flex gap-3">
              {[
                { Icon: Facebook, label: "Facebook" },
                { Icon: Instagram, label: "Instagram" },
                { Icon: Twitter, label: "Twitter" },
              ].map(({ Icon, label }) => (
                <a
                  key={label}
                  href="#"
                  aria-label={label}
                  className="w-9 h-9 rounded-full bg-background/10 flex items-center justify-center hover:bg-background/20 transition-colors"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-heading font-semibold text-base mb-4">Quick Links</h3>
            <ul className="space-y-2.5">
              {[
                { label: "About Us", to: "/about" },
                { label: "How It Works", to: "/how-it-works" },
                { label: "Become a Seller", to: "/become-a-seller" },
                { label: "Become a Distributor", to: "/become-a-distributor" },
                { label: "Become a Wholesaler", to: "/become-a-wholesaler" },
                { label: "Delivery Partner", to: "/delivery-partner" },
              ].map(({ label, to }) => (
                <li key={label}>
                  <Link to={to} className="text-sm text-background/60 hover:text-background transition-colors">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h3 className="font-heading font-semibold text-base mb-4">Categories</h3>
            <ul className="space-y-2.5">
              {["Fruits & Vegetables", "Dairy & Eggs", "Bakery", "Meat & Fish", "Beverages"].map((label) => (
                <li key={label}>
                  <Link to="/products" className="text-sm text-background/60 hover:text-background transition-colors">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-heading font-semibold text-base mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2.5 text-sm text-background/60">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0" />
                <span>Main Road, Boring Road, Patna, Bihar 800001</span>
              </li>
              <li className="flex items-center gap-2.5 text-sm text-background/60">
                <Phone className="w-4 h-4 shrink-0" />
                <span>+91 98765 43210</span>
              </li>
              <li className="flex items-center gap-2.5 text-sm text-background/60">
                <Mail className="w-4 h-4 shrink-0" />
                <span>support@biharimall.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background/60">
            © 2026 Bihari Mall. All rights reserved. Powered by Biharimall Private Limited.
          </p>
          <div className="flex gap-6">
            {[
              { label: "Privacy Policy", to: "/privacy" },
              { label: "Terms of Service", to: "/terms" },
              { label: "Refund Policy", to: "/refund" },
            ].map(({ label, to }) => (
              <Link key={label} to={to} className="text-xs text-background/60 hover:text-background/90 transition-colors">
                {label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
